import { useColors } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { SwitchRenderProps } from "react-aria-components";

interface Props extends SwitchRenderProps {
  testID?: string;
}

export function SwitchAsset(props: Props) {
  const colors = useColors();

  const {
    isSelected,
    isHovered,
    isFocused,
    isDisabled,
    testID = "switch-asset",
  } = props;

  return (
    <div className={styles.container} data-testid={testID}>
      <div
        className={css(
          styles.track,
          {
            backgroundColor: "var(--background-selected-medium)",
          },
          isSelected && {
            backgroundColor: "var(--background-selected-strong)",
          },
          isFocused && {
            boxShadow: "var(--focus-action)",
          },
          isDisabled && {
            backgroundColor: "var(--background-selected-disabled)",
          }
        )}
      />
      <svg
        width="40"
        height="20"
        viewBox="0 0 40 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={css({ position: "absolute" })}
      >
        <path
          className={css(
            styles.dot,
            isSelected && {
              transform: "translateX(20px)",
            }
          )}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
          fill={colors["background-base"]}
        />
        <path
          d="M28.0123 11.5635L25.8957 13.6753C25.6739 13.8967 25.4148 14.0049 25.1184 13.9998C24.8226 13.9943 24.5635 13.8808 24.3412 13.6594C24.1194 13.4375 24.0085 13.1788 24.0085 12.8835C24.0085 12.5876 24.1194 12.329 24.3412 12.1076L26.4418 9.99574L24.3252 7.88388C24.1034 7.66248 23.9951 7.40411 24.0002 7.10874C24.0058 6.81288 24.1194 6.55425 24.3412 6.33285C24.5528 6.11095 24.8094 6 25.1108 6C25.4123 6 25.6739 6.11095 25.8957 6.33285L27.9963 8.44471L30.0969 6.33285C30.3187 6.11095 30.5803 6 30.8817 6C31.1832 6 31.4451 6.11095 31.6673 6.33285C31.8891 6.55425 32 6.81541 32 7.11634C32 7.41728 31.8891 7.67844 31.6673 7.89984L29.5507 10.0117L31.6673 12.1236C31.8891 12.3449 32 12.6036 32 12.8994C32 13.1948 31.8891 13.4481 31.6673 13.6594C31.4557 13.8808 31.1992 13.9915 30.8977 13.9915C30.5963 13.9915 30.34 13.8808 30.1289 13.6594L28.0123 11.5635Z"
          fill={colors["background-base"]}
          className={css(
            styles.icon,
            !isSelected &&
              (isHovered || isFocused) && {
                opacity: 1,
              }
          )}
        />
        <path
          d="M17.6742 6.33463C17.8828 6.54896 18 6.83962 18 7.14268C18 7.44575 17.8828 7.7364 17.6742 7.95073L12.1109 13.6654C11.9023 13.8796 11.6193 14 11.3243 14C11.0293 14 10.7463 13.8796 10.5376 13.6654L8.31234 11.3795C8.10966 11.164 7.99751 10.8752 8.00004 10.5756C8.00258 10.2759 8.11959 9.98924 8.32589 9.77734C8.53219 9.56543 8.81125 9.44523 9.10299 9.44262C9.39472 9.44002 9.67578 9.55522 9.88563 9.76341L11.3243 11.2412L16.1009 6.33463C16.3096 6.12037 16.5925 6 16.8876 6C17.1826 6 17.4656 6.12037 17.6742 6.33463Z"
          fill={colors["background-base"]}
          className={css(
            styles.icon,
            isSelected &&
              (isHovered || isFocused) && {
                opacity: 1,
              }
          )}
        />
      </svg>
    </div>
  );
}

const styles = {
  container: css({
    width: 40,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  track: css({
    width: 38,
    height: 18,
    transition: "fill 0.2s",
    borderRadius: "var(--border-radius-half)",
  }),
  icon: css({
    opacity: 0,
    transition: "opacity 0.1s",
  }),
  dot: css({
    transition: "transform 0.2s",
  }),
};
